import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import { Services, WhyUs } from "./components/site/Services";
import { Process, Results } from "./components/site/Sections";
import Reviews from "./components/site/Reviews";
import QuoteForm from "./components/site/QuoteForm";
import Pricing from "./components/site/Pricing";
import Footer from "./components/site/Footer";
import { PaymentSuccess, PaymentCancel } from "./components/site/PaymentResult";
import QuotePage from "./components/site/QuotePage";
import AdminPage from "./components/site/AdminPage";

const Home = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (hash) setTimeout(() => document.querySelector(hash)?.scrollIntoView(), 300);
  }, [hash]);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <Process />
        <Results />
        <Pricing />
        <Reviews />
        <QuoteForm />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#08090b] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/quote/:token" element={<QuotePage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
